<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <head-banner
        title="Individuelle Software-Lösungen"
        subtitle="Innovative Software-Lösungen auf Ihre Bedürfnisse entworfen. Ihr Partner für die digitale Zukunft.  "
      ></head-banner>
      <section class="pb-20 bg-gray-300 -mt-24">
        <div class="container mx-auto px-4">
          <box-overview></box-overview>
          <intro-section></intro-section>
        </div>
      </section>
      <CloudSection></CloudSection>
      <ExternalSection></ExternalSection>
      <references-banner></references-banner>
      <jobs-banner></jobs-banner>
      <contact-form-overview></contact-form-overview>
      <ContactForm></ContactForm>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "../components/Navbar.vue";
import FooterComponent from "../components/Footer.vue";
import HeadBanner from "../components/HeadBanner.vue";
import BoxOverview from "../components/BoxOverview.vue";
import CloudSection from "../components/CloudSection.vue";
import ExternalSection from "../components/ExternalSection.vue";
import IntroSection from "../components/IntroSection.vue";
import ReferencesBanner from "../components/ReferencesBanner.vue";
import JobsBanner from "../components/JobsBanner.vue";
import ContactForm from "../components/ContactForm.vue";
import ContactFormOverview from "../components/ContactFormOverview.vue";

export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    FooterComponent,
    HeadBanner,
    BoxOverview,
    CloudSection,
    ExternalSection,
    IntroSection,
    ReferencesBanner,
    JobsBanner,
    ContactForm,
    ContactFormOverview
  }
};
</script>

<style scoped>
@import url("../assets/css/ubuntu.css");
</style>
